import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PatientDetailsStatus } from '@ffd/api-client';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-patient-status',
  templateUrl: './patient-status.component.html',
  styleUrls: ['./patient-status.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, NgClass],
})
export class PatientStatusComponent {
  @Input() public status!: PatientDetailsStatus;
  public readonly patientStatus = PatientDetailsStatus;
}
